module.exports = __webpack_public_path__ + "static/media/default.c47555ad.png";